<template>
    <div>
        <button :disabled="!isActive" :class="{ 'mark-disabled': !isActive }" class="btn btn-sm btn-confirm" @click="onClick">{{ t('Download') }}</button>
    </div>
</template>

<script>

export default
{
    components: {},
    props: {
        eventBus: {
            type: Object,
        },
        routeName: {
            type: String
        },
        row: {
            type: Object,
        }
    },
    data() {
        return {
            status: null,
        };
    },
    computed: {
        isActive() {
            return this.status === 'done';
        }
    },
    mounted() {
        this.mountEvents();
        this.setStatus(this.row.status);
    },
    methods: {
        mountEvents() {
            this.eventBus.$on('EventManager:on-message-prepared-data', (data) => {
                if (data[this.row.id]) {
                    this.setStatus(data[this.row.id].status);
                }
            });
        },
        onClick() {
            this.$http.get(this.routeName + '/download/' + this.row.id, {responseType: 'arraybuffer'}).then((response) => {
                this.openInNewWindow(response);
            });
        },
        setStatus(status) {
            this.status = status;
        },
    }
}
</script>

<style lang="sass">
    .mark-disabled {
        opacity: 0.4!important;
    }
</style>


// WEBPACK FOOTER //
// DownloadComponent.vue?384909d0